<script>
import LogisticsDefaults from '@/utils/logisticsDefaults'

export default {
  name: 'LogisticsDefaultSuggestions',
  props: {
    values: { type: Object, required: true },
    disabled: { type: Boolean, default: false }
  },
  emits: ['apply'],
  computed: {
    missing() { return LogisticsDefaults.FIELDS.some(key => LogisticsDefaults.isMissing(this.values[key])) },
    suggestion() { return LogisticsDefaults.suggestions(this.values) },
    accepted() { return LogisticsDefaults.acceptedPayload(this.values).dimension_default_fields || [] },
    stale() { return LogisticsDefaults.staleAccepted(this.values).length > 0 },
    available() { return Object.keys(this.suggestion.values).length > 0 }
  },
  methods: {
    apply() {
      if (!this.disabled && this.available) this.$emit('apply', LogisticsDefaults.applySuggestions(this.values))
    }
  }
}
</script>

<template>
  <div v-if="missing || accepted.length" class="q-pa-sm bg-blue-1 rounded-borders text-body2" role="status">
    <div v-if="stale" class="text-negative" role="alert">치수와 적용한 계산값이 일치하지 않습니다. 계산값을 비운 뒤 다시 적용하거나 중량·CBM을 직접 수정하세요.</div>
    <div v-if="accepted.includes('weight_kg')">항공 부피중량 계산값 적용: {{ values.weight_kg }} kg</div>
    <div v-if="accepted.includes('volume_cbm')">CBM 계산값 적용: {{ values.volume_cbm }}</div>
    <div v-if="missing" class="text-weight-medium">빈값·0인 물류값의 치수 계산 제안</div>
    <template v-if="missing && available">
      <div v-if="suggestion.values.weight_kg !== undefined">항공 부피중량: {{ suggestion.values.weight_kg }} kg</div>
      <div v-if="suggestion.values.volume_cbm !== undefined">부피: {{ suggestion.values.volume_cbm }} CBM</div>
      <q-btn class="q-mt-xs" flat dense color="primary" label="누락값에 계산값 적용" :disable="disabled" @click="apply" />
    </template>
    <div v-else-if="missing" class="text-caption">{{ suggestion.reason }}</div>
    <div class="text-caption">항공 부피중량은 가로 × 세로 × 높이(cm) ÷ 6,000으로 계산하며 실측중량이 아닙니다. 기존 양수 값은 유지합니다. 계산값 적용 후 저장하세요.</div>
  </div>
</template>
